import React from 'react';
import PropTypes from 'prop-types';
import UploadedFile from '../../../../common/components/UploadedFile';
import styles from './styles.module.scss';

const TabPropertyView = ({
                           items = []
                         }) => {

  return (
    <div className={styles.formContainer}>
      {items.map((item, ind) => (
        <UploadedFile
          {...item}
          containerClassName={styles.item}
          key={ind}
        />
      ))}
    </div>
  );
};

TabPropertyView.propTypes = {
  items: PropTypes.array
};

export default TabPropertyView;
